import type { CSSProperties } from "react";

export function magikVars(
  color1: string,
  color2: string,
  intensity: number,
  speed: number
): CSSProperties {
  return {
    ["--magik-color1" as string]: color1,
    ["--magik-color2" as string]: color2,
    ["--magik-glow" as string]: `${intensity}px`,
    ["--magik-glow2" as string]: `${intensity * 2}px`,
    ["--magik-speed" as string]: `${speed}s`,
  };
}

export function magikVarsSmall(
  color1: string,
  color2: string,
  intensity: number,
  speed: number
): CSSProperties {
  return {
    ["--magik-color1" as string]: color1,
    ["--magik-color2" as string]: color2,
    ["--magik-glow" as string]: `${intensity * 0.5}px`,
    ["--magik-glow2" as string]: `${intensity}px`,
    ["--magik-speed" as string]: `${speed}s`,
  };
}
